// src/admin/views/ArchiveEventListView.js
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import PageHeader from '../components/PageHeader'
import { useAdminStore } from '../store/AdminStore'

function ArchiveEventListView({ onSelect }) {
  const orgId = useAdminStore((state) => state.orgId)
  const orgName = useAdminStore((state) => state.orgName)
  const [events, setEventData] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
    if (orgId) {
      apiClient.get(`/gskapi/event/org/${orgId}`)
        .then((response) => {
          setEventData(response.data)
        })
        .catch((error) => {
          console.error('Error fetching event data:', error)
        })
    }
  }, [orgId])

  return (
    <>
      <PageHeader backTo={'/admin'} pageName={'Archived Events'} />
      {orgName && (
        <div style={{ textAlign: 'center', fontWeight: 'bold', margin: '10px 0' }}>
          {orgName}
        </div>
      )}
      <div className="admin-list" style={{ marginTop: '20px' }}>
        {events
          .filter((e) => moment(e.eventDate).year() < moment().year())
          .map((event) => (
            <div
              key={event.eventId}
              className="admin-list-item"
              onClick={() => {
                if (onSelect) {
                  onSelect(event.eventId)
                } else {
                  navigate(`/admin/event?eventId=${event.eventId}`)
                }
              }}
            >
              <span className="admin-list-item-name">
                {moment(event.eventDate).format('YYYY-MM-DD')} - {event.courseName}{' '}
                {event.rainout ? ' (RAINOUT)' : ''}
              </span>
              <span className="admin-list-item-arrow">›</span>
            </div>
          ))}
      </div>
    </>
  )
}

export default ArchiveEventListView
